import { FlagArgentina, FlagBrasil, FlagChile, FlagColombia, FlagEcuador, FlagMexico, FlagPeru, FlagUruguay, FlagUSA } from '../../Icons/Flags'
import { useState } from 'react'
import { IoIosAlert, IoMdDownload } from 'react-icons/io'
import { IoCloseSharp } from 'react-icons/io5'

const mockData = [
	{
		icon: <FlagArgentina width='30' height='30' />,
		name: 'Argentina',
		link: '',
	},
	{
		icon: <FlagBrasil width='30' height='30' />,
		name: 'Brasil',
		link: '',
	},
	{
		icon: <FlagChile width='30' height='30' />,
		name: 'Chile',
		link: 'https://assets.mydna.company/payroll/sheets/myDNA_payroll-chile.xlsx',
	},
	{
		icon: <FlagColombia width='30' height='30' />,
		name: 'Colombia',
		link: '',
	},
	{
		icon: <FlagEcuador width='30' height='30' />,
		name: 'Equador',
		link: '',
	},
	{
		icon: <FlagMexico width='30' height='30' />,
		name: 'México',
		link: '',
	},
	{
		icon: <FlagPeru width='30' height='30' />,
		name: 'Peru',
		link: '',
	},
	{
		icon: <FlagUSA width='30' height='30' />,
		name: 'USA',
		link: '',
	},
	{
		icon: <FlagUruguay width='30' height='30' />,
		name: 'Uruguai',
		link: '',
	},
]

const columnsData = [
	{
		color: 'tw-bg-purple-500',
		title: 'Columnas Moradas',
		label: 'Obligatorias',
		description: 'Deben completarse.',
		note: 'No cambies el nombre de las columnas.',
		img: 'https://assets.mydna.company/payroll/field1.png',
	},
	{
		color: 'tw-bg-blue-950',
		title: 'Columnas Azules',
		label: 'Opcionales',
		description: 'No son obligatorias.',
		note: 'No cambies el nombre de las columnas.',
		img: 'https://assets.mydna.company/payroll/field2.png',
	},
	{
		color: 'tw-bg-green-400',
		title: 'Columnas Verdes',
		label: 'Adicionales',
		description: 'Se pueden editar o agregar nuevas columnas.',
		note: '',
		img: 'https://assets.mydna.company/payroll/field3.png',
	},
]

const DownloadPayslip = () => {
	const [isOpen, setIsOpen] = useState(false)

	const toggleModal = () => {
		setIsOpen(!isOpen)
	}

	const handleDownload = link => {
		if (!link) return
		const a = document.createElement('a')
		a.href = link
		a.target = '_blank'
		a.rel = 'noopener noreferrer'
		document.body.appendChild(a)
		a.click()
		document.body.removeChild(a)
	}

	return (
		<>
			<div
				onClick={toggleModal}
				className='tw-rounded-xl border tw-cursor-pointer tw-flex tw-items-center tw-text-sm tw-px-4 tw-py-2 tw-bg-white tw-text-purple-500 tw-whitespace-nowrap'
			>
				<IoMdDownload size={16} className='tw-mr-2' /> Descargar modelo de plantilla
			</div>

			{isOpen && (
				<div className='tw-fixed tw-inset-0 tw-bg-black/50 tw-flex tw-justify-center tw-items-center tw-z-50 tw-p-0'>
					<div className='tw-bg-white tw-rounded-lg tw-shadow-lg 2xl:tw-w-3/5 tw-w-4/5 tw-p-6 tw-relative'>
						<div>
							<div className='tw-flex tw-justify-between tw-items-center tw-border-b tw-pb-3 tw-mb-2'>
								<div className='tw-text-lg tw-font-black'>Descargar Plantilla de Nómina</div>
								<IoCloseSharp
									size={22}
									onClick={toggleModal}
									className='tw-text-gray-500 hover:tw-text-gray-700 tw-flex tw-items-center tw-cursor-pointer'
								/>
							</div>
							<div className='tw-w-4/5 tw-mb-10'>
								Elija la plantilla de su país para asegurarse de que todos los detalles de la nómina estén alineados con las regulaciones locales.
							</div>
						</div>
						<div className='tw-grid tw-grid-cols-1 lg:tw-grid-cols-3 tw-gap-3 tw-mb-10'>
							{mockData.map((item, index) => (
								<div
									className={`border tw-rounded-2xl tw-p-4 tw-shadow-md ${!item.link ? 'tw-bg-gray-200 tw-opacity-50' : 'tw-cursor-pointer'}`}
									key={index}
									onClick={() => handleDownload(item.link)}
									disabled={!item.link}
								>
									<div className='tw-flex tw-items-center tw-justify-between'>
										<div className='tw-flex tw-items-center'>
											<div className='tw-object-contain'>{item.icon}</div>
											<div className='tw-ml-4 tw-font-medium'>{item.name}</div>
										</div>
										<div
											onClick={() => handleDownload(item.link)}
											disabled={!item.link}
											className={`tw-flex tw-items-center tw-justify-center tw-bg-purple-50 tw-h-10 tw-w-10 tw-rounded-full ${
												!item.link ? 'tw-opacity-50 ' : ''
											}`}
										>
											<IoMdDownload size={18} className='tw-text-purple-500' />
										</div>
									</div>
								</div>
							))}
						</div>
						<div className='tw-mt-4'>
							<div className='tw-flex tw-space-x-2 tw-items-center'>
								<div className='tw-font-bold'>Cómo usar la Plantilla de Nómina</div>
							</div>
							<div className='tw-mt-4 tw-flex  tw-justify-center tw-space-x-4 tw-px-6'>
								{columnsData.map((col, index) => (
									<div key={index} className='tw-w-2/5 tw-flex tw-flex-col tw-justify-between tw-p-4  tw-rounded-lg'>
										<div>
											<div className='tw-flex tw-items-center tw-space-x-2'>
												<div className='tw-flex tw-items-center tw-font-bold'>
													<span className={`tw-h-3 tw-w-3 tw-rounded-full ${col.color} tw-mr-2`}></span>
													{col.title}
												</div>
												<div className='tw-text-gray-500 tw-text-xs tw-py-1 tw-px-2 border tw-rounded-lg'>{col.label}</div>
											</div>
											<div className='tw-w-5/6 tw-mt-2'>
												{col.description} {col.note && <span className='tw-font-bold'>{col.note}</span>}
											</div>
										</div>
										<img src={col.img} className='tw-mt-4' alt={`${index + 1}`} />
									</div>
								))}
							</div>
						</div>
					</div>
				</div>
			)}
		</>
	)
}

export default DownloadPayslip
